<div
  [ngStyle]="{'border-bottom-color': borderColor}"
  class="competitor-brand">
  <div>
    <div
      class="competitor-brand__brand-name"
      data-cy="brand-summary.brand-name">
      {{ brandName }}
    </div>

    <div class="competitor-brand__stores-included">
      {{ storeNumberKey | translate:{storeNumber: storeNumber} }}
    </div>
  </div>

  <div class="percentage">
    <div class="percentage__label">{{ 'Foot traffic' | translate }}</div>
    <coa-icon-tooltip [tooltip]="percentageTooltip | translate" class="percentage__tooltip"></coa-icon-tooltip>
    <coa-percentage-change [value]="percentageValue" class="percentage__value"></coa-percentage-change>
  </div>

  <div
    *ngIf="paymentsEnabled$ | async"
    class="payment">
    <div class="payment__label">{{ 'Payment conversion' | translate }}</div>
    <coa-icon-tooltip [tooltip]="paymentTooltip" class="payment__tooltip"></coa-icon-tooltip>
    <span class="payment__value">{{paymentValue + ' %'}}</span>
  </div>
</div>
